import React from 'react';
import {ContentWrapper} from '@components';
import {useTranslation} from 'react-i18next';

const PrivacyPolicy = () => {
  const {t} = useTranslation();

  return (
    <div
      className="bg-white text-gray-800 font-sans max-w-3xl mx-auto py-6 px-4 leading-relaxed"
      style={{fontFamily: 'Helvetica, Arial, sans-serif'}}>
      <p className="font-bold mb-2">
        Privacy Policy – Next Level Technology Corporation
      </p>

      <p className="mb-2">
        Effective Date: February 1, 2026
        <br />
        Last Updated: February 1, 2026
      </p>

      <p className="mb-4">
        Next Level Technology Corporation (&quot;Next Level,&quot;
        &quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) values your privacy.
        This Privacy Policy explains how we collect, use, store, and delete
        personal information when you use the Next Level Technology mobile
        application (the &quot;App&quot;).
      </p>

      <p className="font-bold mb-2">INFORMATION WE COLLECT</p>

      <p className="font-bold mb-1">Information You Provide</p>
      <p className="mb-2">
        We may collect information you voluntarily provide, including:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Name or username</li>
        <li>Email address</li>
        <li>Profile picture (uploaded or taken using your device camera)</li>
        <li>Account-related information</li>
      </ul>

      <p className="font-bold mb-1">Camera Usage (Dual Purpose)</p>
      <p className="mb-2">
        The App uses your device camera only with your permission for:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Scanning QR codes to access discounts or promotions</li>
        <li>Taking or uploading a profile picture</li>
      </ul>

      <p className="mb-4">
        Camera access is used only when you initiate these actions.
      </p>

      <p className="font-bold mb-1">Automatically Collected Information</p>
      <p className="mb-4">
        We may collect limited technical data such as device type, operating
        system, app version, and anonymous usage data for performance
        improvement.
      </p>

      <p className="font-bold mb-2">HOW WE USE YOUR INFORMATION</p>
      <p className="mb-4">
        We use collected information to create and manage your account,
        personalize your experience, display profile images, enable QR code
        functionality, improve security, and respond to support requests. We do
        not sell personal data.
      </p>

      <p className="font-bold mb-2">IMAGE STORAGE AND RETENTION</p>
      <p className="mb-4">
        Profile images are stored securely on our servers and used solely for
        personalization. Data is retained only while your account remains active
        unless deletion is requested.
      </p>

      <p className="font-bold mb-2">YOUR RIGHT TO DELETE YOUR DATA</p>
      <p className="mb-4">
        You may request deletion of your account and all associated personal
        data, including images.
        <br />
        Requests can be made through the app or by emailing{' '}
        <a
          href="mailto:info@nextleveltechapp.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-red hover:underline">
          info@nextleveltechapp.com
        </a>
        .<br />
        Once verified, all data will be permanently deleted within a reasonable
        timeframe unless required by law.
      </p>

      <p className="font-bold mb-2">DATA SECURITY</p>
      <p className="mb-4">
        We use reasonable administrative, technical, and physical safeguards to
        protect your information.
      </p>

      <p className="font-bold mb-2">CHILDREN&apos;S PRIVACY</p>
      <p className="mb-4">
        The App is not intended for children under 13. We do not knowingly
        collect personal data from children.
      </p>

      <p className="font-bold mb-2">CHANGES TO THIS POLICY</p>
      <p className="mb-4">
        We may update this Privacy Policy periodically. Continued use of the App
        indicates acceptance of updates.
      </p>

      <p className="font-bold mb-2">CONTACT US</p>
      <p className="mb-2">
        Next Level Technology Corporation
        <br />
        Email:{' '}
        <a
          href="mailto:info@nextleveltechapp.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-red hover:underline">
          info@nextleveltechapp.com
        </a>
        <br />
        Website:{' '}
        <a
          href="https://nextleveltechapp.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-red hover:underline">
          https://nextleveltechapp.com
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
